import React, {
  Fragment,
  useContext,
  useState,
  useRef,
  useEffect,
} from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FetchContext } from 'js/components/fetch';

import {
  SortableTable,
  tableSortDirection,
  ActivityIndicatorCard,
} from 'js/components/design-system';
import EmptyState from 'js/components/controls/empty-state';
import ClientPage from '../client-page';
import { ClientProvider } from '../client-context';
import { onMountEffect, getClientLogEffect } from './effects';
import { getClientLogColumns } from './functions';
import ClientLogPrintHeader from './client-log-print-header';
import { PrintFooter } from 'js/components/print';

const ClientLog = () => {
  const { t } = useTranslation();
  const { api = {} } = useContext(FetchContext);
  const {
    params: { id, clientCode = '00' },
  } = useRouteMatch();
  const getClientLogAbortControllerRef = useRef(null);
  const [loadingLogData, setLoadingLogData] = useState(false);
  const [logData, setLogData] = useState([]);

  useEffect(
    onMountEffect({
      abortControllerRefs: [getClientLogAbortControllerRef],
      setLoadingLogData,
    }),
    []
  );

  useEffect(
    getClientLogEffect({
      t,
      api,
      clientId: id,
      clientCode,
      setLoadingLogData,
      setLogData,
      getClientLogAbortControllerRef,
    }),
    []
  );

  return (
    <ClientPage
      className="case-log"
      title={t('components.ClientLog.title')}
      actions={
        <button
          className="button button-highlight page-action-button"
          disabled={loadingLogData}
          onClick={() => window.print()}
        >
          {t('common.print')}
        </button>
      }
    >
      <ClientLogPrintHeader
        title={t('components.ClientLog.printHeaderTitle', { id, clientCode })}
        heading={t('components.ClientLog.printHeaderHeader')}
      />

      {loadingLogData && <ActivityIndicatorCard />}
      {!loadingLogData && (
        <Fragment>
          {logData.length === 0 && (
            <EmptyState title={t('components.ClientLog.emptyStateMessage')} />
          )}
          {logData.length > 0 && (
            <SortableTable
              columns={getClientLogColumns(t)}
              data={logData}
              initialSortColumnKey={'date'}
              initialSortDirection={tableSortDirection.desc}
              printManaged={true}
            />
          )}
        </Fragment>
      )}
      <PrintFooter />
    </ClientPage>
  );
};

const ClientLogWithContext = (props) => (
  <ClientProvider>
    <ClientLog {...props} />
  </ClientProvider>
);

export default ClientLogWithContext;
